module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page-profiel-overzicht",
    attrs: {
      "id": "page-profiel-overzicht"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', [_vm._v("Controleer je gegevens voor het versturen")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', [_c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Huidige baan\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [(_vm.userProfile.baan1) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.userProfile.baan1.profileText) + " "), _c('br'), _vm._v("Gewenst aantal dagen werkzaam: " + _vm._s(_vm.getUrenLabel(_vm.userProfile.uren1)) + "\n                        ")]) : _c('span', [_vm._v("Niet ingevuld!")])])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Gewenste combinatie\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [(_vm.userProfile.baan2) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.userProfile.baan2.label) + " "), _c('br'), _vm._v("Gewenst aantal dagen werkzaam: " + _vm._s(_vm.getUrenLabel(_vm.userProfile.uren2)) + "\n                        ")]) : _c('span', [_vm._v("Niet ingevuld!")])])]), _vm._v(" "), (_vm.userProfile.baan1 && _vm.userProfile.baan1.isTeacher === false) ? _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Lesbevoegdheid\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.userProfile.bevoegdheid ? 'Ja' : 'Nee') + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Naam\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.userProfile.naam) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("E-mailadres\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_vm._v("\n                        " + _vm._s(_vm.userProfile.email) + "\n                    ")])]), _vm._v(" "), (_vm.userProfile.opMaat && _vm.userProfile.opDeHoogteBrengenProjecten) ? _c('div', [_c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Woonplaats\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_vm._v("\n                            " + _vm._s(_vm.userProfile.woonplaats) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Opleiding\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_vm._v("\n                            " + _vm._s(_vm.userProfile.opleiding) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row row--form-item"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }, [_vm._v("Huidige functie\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_vm._v("\n                            " + _vm._s(_vm.userProfile.huidigeFunctie) + "\n                        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8-sm"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.submitHandler
    }
  }, [_vm._v("Verstuur")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46048520","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-profiel-overzicht.vue
// module id = 142
// module chunks = 0